import axios, { AxiosResponse } from 'axios';
import pathfinder from '@fiverr-private/pathfinder';

export const dmFieldOptionsUrl = pathfinder('get_dm_field_options');

export interface TimezoneFieldValue {
    key: string;
    translation_key: string;
    meta: {
        offset_display: string;
        utc_offset_in_hours: number;
        common_name: string;
        display_name: string;
    };
}

export interface RegionFieldValue extends GenericFieldValue {
    meta: {
        display_name: string;
    };
}

export interface GenericFieldValue {
    key: string;
    translation_key: string;
}

export interface Field<T> {
    type: string;
    field_id: string;
    variant: string;
    values: T[];
}

export interface FieldsOptions<T> {
    fields: Field<T>[];
}

export interface FieldOptionsResponse<T> {
    data: FieldsOptions<T>;
}

export type FieldName =
    | 'timezone'
    | 'timeline'
    | 'time_commitment'
    | 'hiring_duration'
    | 'brief_close_reason'
    | 'region';

type FieldVariant = 'v1' | 'v2';

type VariantParams = Record<FieldName, FieldVariant>;

export const getFieldsOptions = async <T>(
    fields: FieldName[],
    variants?: Partial<VariantParams>
): Promise<AxiosResponse<FieldsOptions<T>>> =>
    axios.get<FieldsOptions<T>>(dmFieldOptionsUrl, {
        params: {
            field: fields,
            ...Object.entries(variants || {}).reduce((acc, [key, value]) => {
                acc[`variant.${key}`] = value;
                return acc;
            }, {} as Record<string, string>),
        },
        paramsSerializer: (params) => {
            const searchParams = new URLSearchParams();

            for (const key in params) {
                const value = params[key];
                if (Array.isArray(value)) {
                    value.forEach((v) => searchParams.append(key, v));
                } else {
                    searchParams.append(key, value);
                }
            }

            return searchParams.toString();
        },
    });
